import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'lobby-widget',
    loadComponent: () => import('@components/lobby-widget/lobby-widget').then((m) => m.LobbyWidget),
  },
  {
    path: 'footer-widget',
    loadComponent: () =>
      import('@components/footer-widget/footer-widget').then((m) => m.FooterWidget),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'footer-widget',
  },
  {
    path: '**',
    redirectTo: 'footer-widget',
  },
];
